<template>
  <div class="th_info">
    <div class="th_info_top">{{$t('main.text309')}}</div>
    <div class="th_info_main">
        <div class="th_tit1">{{$t('main.text309')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text310')}}</div>
            <div class="th_tit4">{{overall_time(data_all.c_time)}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text326')}}</div>
            <div class="th_tit4">{{data_all.tx_id}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text349')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text458')}}</div>
            <div class="th_tit4">{{data_all.token_type}} {{set_num3(data_all.amount)}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text739')}}</div>
            <div class="th_tit4">{{data_all.token_type}} {{data_all.fee}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text740')}}</div>
            <div class="th_tit4">{{data_all.token_type}} {{data_all.fixed_fee}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text350')}}</div>
            <div class="th_tit4">{{data_all.to_token_type}} {{set_num3(data_all.receive)}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text351')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text352')}}</div>
            <div class="th_tit4">{{data_all.address_details.name}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text280')}}</div>
            <div class="th_tit4">{{data_all.address_details.account_number}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text348')}}</div>
            <div class="th_tit4">{{data_all.address_details.beneficiary_name}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text353')}}</div>
            <div class="th_tit4">{{data_all.address_details.swift_code}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text277')}}</div>
            <div class="th_tit4">{{data_all.address_details.address}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text354')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text355')}}</div>
            <div class="th_tit4">{{data_all.address_details.intermediary_name}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text356')}}</div>
            <div class="th_tit4">{{data_all.address_details.intermediary_country}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text357')}}</div>
            <div class="th_tit4">{{data_all.address_details.intermediary_swift_code}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text358')}}</div>
            <div class="th_tit4">{{data_all.address_details.intermediary_address}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text359')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text360')}}</div>
            <div class="th_tit4">{{data_all.purpose}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text35')}}</div>
            <div class="th_tit4">
                <span v-if="data_all.email">{{data_all.email}}</span>
                <span v-else>-</span>
            </div>
        </div>
        <div class="th_tit2" v-if="data_all.status==22">
            <!-- <div class="th_tit3">Refuse Reason</div>text489 -->
            <div class="th_tit3">{{$t('main.text489')}}</div>
            <div class="th_tit4">{{ des_fun(data_all.des)}}</div>
        </div>
        
    </div>
  </div>
</template>

<script>
import {crypto_get} from '@/api/api';

export default {
    data() {
        return {
            fiat_info_tx_id:'',
            fiat_info_id:'',
            data_all:{
                address_details:{}
            },
        }
    },
    created() {
        this.fiat_info_tx_id=sessionStorage.getItem('fiat_info_tx_id');
        this.fiat_info_id=sessionStorage.getItem('fiat_info_id');
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
        sessionStorage.removeItem('fiat_info_id');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',this.fiat_info_tx_id=='-'?'':this.fiat_info_tx_id);
        this.get_list();
    },
    methods: {
        get_list(){
            crypto_get({id:this.fiat_info_id}).then(res=>{
                if (res.data.code==200) {
                    this.data_all=res.data.data;
                    // console.log(this.data_all);
                }
            })
        },
        des_fun(v){
            if (v) {
                let res;
                v = eval('(' + v + ')')
                if(this.v_lan=='ch'){
                    res = v.reason_ch || '-';
                }else if(this.v_lan=='jp'){
                    res = v.reason_jp || '-';
                }else{
                    res = v.reason_en || '-';
                }
                return res;
            }
        }

    },
}
</script>

<style scoped>
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1px solid #041E35;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
</style>